import React,{Component} from 'react';
import './UpdateEmail.css';

import { 
    accountBackground, logo
} from '../../_utils/images';

// redux
import _ from 'lodash';
import { API_URL } from '../../_utils/config';

import jwt from 'jsonwebtoken';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Footer from '../../components/Footer/Footer';
import routes from '../../_utils/routes';
import Message from '@acri-tools/react-tools/components/Message/Message';
import request from '@acri-tools/react-tools/utils/request';
import { push_history } from '@acri-tools/react-tools/utils/global';

interface MyProps{
    history?:any,
    match?:any,

    // redux
    login?:any
}


class UpdateEmail extends Component<MyProps,{}>{
    state={
        email:'',
        previous_email: '',

        message:'',
        messageType: 'warn',
    }

    componentDidMount() {
        let decoded:any = jwt.decode(this.props.match.params.token);
        this.setState({
            email: decoded.email,
            previous_email: decoded.previous_email,
        })
    }

    render(){
        return (
        <Page 
            footer={<Footer/>}
            id="update-email"
            title="Update email"
            banner={{
                bannerImage:accountBackground,
                topBar:{
                    routes: routes,
                    logo: logo
                }
            }}
        >
            <div className="page-content">
                <div className="row-centered-column">
                    <div className="content-div"> 
                        <div className="title-3">Update Email</div>
                        <p>You are about to change your email from</p>
                        <div className="email-example">{this.state.previous_email}</div>
                        <h2 className="divider"><div className="line"/><span>TO</span><div className="line"/></h2>
                        <div className="email-example">{this.state.email}</div>

                        <Message message={ this.state.message } type={ this.state.messageType }/>

                        <div className="custom-button blue inverted alt" onClick={this.updateEmail}><i className="fas fa-envelope"/> CONFIRM UPDATE</div>
                    </div>
                </div>
            </div>
        </Page>
        );
    }

    onEnter = ( e:any, cb:any ) =>{
        if( e.keyCode === 13 ){
            if(cb) cb();
        }
    }

    updateEmail = () =>{
        if(window.confirm(`Are you sure you want to update your email ?`)){
            this.setState({ updateEmailLoading:true });
            request(`${API_URL}/api/user-manager/v1/verifyUpdateEmail/${this.props.match.params.token}`,{
                method:'get',
                responseType:'json'
            })
            .then((res:any)=>{
                push_history('/account');
            })
            .catch(e=>{
                this.setState({
                    loading:false,
                    message: e.response && e.response.data && e.response.data.error  ? e.response.data.error : 'An error has occured.',
                    messageType: 'error'
                })
            })
        }
    }

};

// export default App;
export default UpdateEmail;
